import {
  CARTON_COMP_CODE,
  CARTON_DI_LOCATION,
  CARTON_GRAPH,
  CARTON_PLANNED_GRAPH,
  CARTON_PLANNED_REPORT,
  CARTON_REPORT,
  CARTON_TABLE,
} from "../../config/apiList";
import { contentType, methodType } from "../../config/auth";
import { apiRequest } from "../../utility/apiWrapper";

export const getPlannedReceivedTable = (
  startDate,
  endDate,
  location,
  compCode,
  page,
  limit
) => {
  const requestURL = CARTON_TABLE;
  let obj = { from_date: startDate, to_date: endDate };

  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }

  if (compCode && compCode.length) {
    obj["comp_code_list"] = compCode.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: { ...obj, page: page, limit: 7 },
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getPlannedReceivedGraph = (
  startDate,
  endDate,
  location,
  compCode,
  page
) => {
  const requestURL = CARTON_GRAPH;
  let obj = { from_date: startDate, to_date: endDate, page: page, limit: 7 };

  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }

  if (compCode && compCode.length) {
    obj["comp_code_list"] = compCode.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getPlannedCartonGraph = (
  startDate,
  endDate,
  location,
  compCode,
  dayRange
) => {
  const requestURL = CARTON_PLANNED_GRAPH;
  let obj = {
    from_date: startDate,
    to_date: endDate,
    stock_day_range: dayRange,
  };

  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }

  if (compCode && compCode.length) {
    obj["comp_code_list"] = compCode.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getPlannedReceivedReport = (
  startDate,
  endDate,
  location,
  compCode,
  requestId
) => {
  const requestURL = CARTON_REPORT;
  let obj = { from_date: startDate, to_date: endDate, request_id: requestId };

  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }

  if (compCode && compCode.length) {
    obj["comp_code_list"] = compCode.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getPlannedCartonReport = (
  startDate,
  endDate,
  location,
  compCode,
  dayRange
) => {
  const requestURL = CARTON_PLANNED_REPORT;
  let obj = {
    from_date: startDate,
    to_date: endDate,
    stock_day_range: dayRange,
  };

  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }

  if (compCode && compCode.length) {
    obj["comp_code_list"] = compCode.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getCompCode = () => {
  const requestURL = CARTON_COMP_CODE;
  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: {},
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getDILocations = () => {
  const requestURL = CARTON_DI_LOCATION;
  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: {},
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};
